import { parseISO, format } from 'date-fns';

export function parseDate(dateToParse) {
  return parseISO(dateToParse);
}

export function formatDate(dateToFormat, f = 'dd.MM.yyyy') {
  if (typeof dateToFormat === 'string') {
    dateToFormat = parseDate(dateToFormat);
  }
  return format(dateToFormat, f, { timeZone: 'Europe/Bern' });
}
